<template lang="html">
  <section class="slider-home row-center">
    <div class="contenedor-slider container">
      <slick ref="slick" :options="slickOptions">
        <div class="slide">
          <div class="slide-wrapper row-between ais">
            <div class="contenedor-texto column-center">
              <h4 class="subtitle">{{ $t("home.slider2.title") }}</h4>

              <h3 class="title">{{ $t("home.slider2.subtitle") }}</h3>

              <router-link class="btn-rounded-blue" :to="$t('home.slider2.enlace')">{{
                $t("moreInfo")
              }}</router-link>
            </div>

            <div class="contenedor-imagen row-center">
              <img :src="$t('home.slider2.gif')" alt="slider home" />
            </div>
          </div>
        </div>
        <div class="slide">
          <div class="slide-wrapper row-between ais">
            <div class="contenedor-texto column-center">
              <h4 class="subtitle">{{ $t("home.slider1.title") }}</h4>
              <h1 class="title">{{ $t("home.slider1.subtitle") }}</h1>

              <router-link class="btn-rounded-blue" :to="$t('/productos')">{{
                $t("moreInfo")
              }}</router-link>
            </div>

            <div class="contenedor-imagen row-center">
              <img :src="$t('home.slider1.gif')" alt="slider home" class="w-100 h-100" />
            </div>
          </div>
        </div>
        <!-- <div class="slide" v-if="lang=='es'">
          <div class="slide-wrapper row-between ais">
            <div class="contenedor-texto column-center">
              <h4 class="subtitle">{{ $t("home.slider3.title") }}</h4>

              <h3 class="title">{{ $t("home.slider3.subtitle") }}</h3>

              <router-link class="btn-rounded-blue" :to="$t('home.slider3.enlace')">{{
                $t("moreInfo")
                }}</router-link>
            </div>

            <div class="contenedor-imagen row-center">
              <img :src="$t('home.slider3.gif')" alt="slider home" />
            </div>
          </div>
        </div> -->


        <div class="slide" v-if="lang == 'es'">
          <div class="slide-wrapper row-between ais">
            <div class="contenedor-texto column-center">
              <h4 class="subtitle">{{ $t("home.slider4.title") }}</h4>

              <h3 class="title">{{ $t("home.slider4.subtitle") }}</h3>

              <router-link class="btn-rounded-blue" :to="$t('home.slider4.enlace')">{{
                $t("moreInfo")
              }}</router-link>
            </div>

            <div class="contenedor-imagen row-center">
              <img :src="$t('home.slider4.gif')" alt="slider home" />
            </div>
          </div>
        </div>
      </slick>
    </div>
  </section>
</template>

<script lang="js">
import Slick from 'vue-slick';
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'hablan-de-nosotros',
  data() {
    return {
      slickOptions: {
        slidesToShow: 1,
        arrows: true,
        dots: true,
        autoplay: true
      },
    }
  },
  components: { Slick },
  computed: {
    ...mapGetters({
      lang: 'getLanguage'
    })
  },
  methods: {
    next() {
      this.$refs.slick.next();
    },

    prev() {
      this.$refs.slick.prev();
    },

    reInit() {
      // Helpful if you have to deal with v-for to update dynamic lists
      this.$nextTick(() => {
        this.$refs.slick.reSlick();
      });
    },
  }
}
</script>

<style scoped>
.slide {
  text-align: left;
}

.slider-home {
  padding: 110px 0 0px 0;
  width: 100%;
  display: inline-block;
}

.contenedor-texto {
  width: 50%;
  max-width: 500px;
  text-align: left;
  -ms-align-items: flex-start;
  align-items: flex-start;
  -webkit-align-items: flex-start;
  padding-left: 100px;
}

.contenedor-imagen {
  width: 50%;
  height: 600px;
  display: inline-block;
}

.contenedor-imagen img {
  max-width: 100%;
  max-height: 100%;
  opacity: 0;
  transition: 1s;
}

.slick-active .contenedor-imagen img {
  opacity: 1;
}

.title {
  color: #3374b0;
  margin-bottom: 30px;
  width: 100%;
  text-align: left;
  opacity: 0;
  transform: translateX(-100vw);
  transition: 0.8s;
  transition-delay: 0.3s;
}

.slick-active .title {
  opacity: 1;
  transform: translateX(0);
}

.subtitle {
  font-size: 20px;
  padding: 10px;
  color: #1d1d1d;
  font-family: "Ubuntu Mono", sans-serif;
  position: relative;
  display: inline-block;
  margin-bottom: 30px;
  opacity: 0;
  transform: translateX(-100vw) skew(-50deg, 0deg);
  transition: 1s;
}

.slick-active .subtitle {
  transform: translateX(-40px);
  opacity: 1;
}

.subtitle::before {
  position: absolute;
  left: 0px;
  bottom: 2px;
  height: 15px;
  width: 80px;
  display: inline-block;
  background: #3374b0;
  opacity: 0.2;
  content: "";
}

.btn-rounded-blue {
  transform: translateY(100px);
  opacity: 0;
  transition: 0.6s;
  transition-delay: 0.6s;
}

.slick-active .btn-rounded-blue {
  opacity: 1;
  transform: translateY(0);
}

@media screen and (max-width: 600px) {
  .contenedor-texto {
    width: 100%;
    max-width: 100%;
    padding: 0 10px;
    padding: 0px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .slick-active .subtitle {
    transform: translateX(-0);
    text-align: center;
  }

  .contenedor-texto h4.subtitle,
  .contenedor-texto h3.title {
    max-width: 250px;
  }

  .slick-active .title {
    text-align: center;
  }

  .contenedor-imagen {
    height: auto;
    margin: 0 auto;
  }

  .slider-home {
    padding-top: 70px;
  }

  .slick-arrow::focus {
    outline: none;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/parts/slider-home.vue